/** regions: English + Arabic (Arabic is a draft for native review). Generated/merged by the i18n helper; edit freely. */
const en = {
  "manage": "Players & content",
  "editShape": "Edit shape",
  "tabPlayers": "Players · {n}",
  "tabContent": "Content · {n}",
  "m_location": "Inside",
  "m_included": "Added by hand",
  "m_excluded": "Taken out by hand",
  "m_nearby": "Nearby",
  "mNearby": "{d} outside",
  "src_manual": "Location set by hand",
  "src_device": "Device location",
  "src_ip": "Estimated from internet address",
  "src_none": "No location",
  "online": "Online",
  "offline": "Offline",
  "inThisRegion": "In this region",
  "outsideOrOut": "Taken out or just outside",
  "noPlayersIn": "No players are in this region yet.",
  "takeOut": "Take out",
  "useLocation": "Use its location",
  "removeFromRegion": "Remove",
  "putBack": "Put back",
  "addToRegion": "Add",
  "excludeQ": "Take “{name}” out of {region}? It stays out even while its location is inside.",
  "player_include": "{name} added to {region}.",
  "player_exclude": "{name} taken out of {region}.",
  "player_auto": "{name} follows its location for {region} again.",
  "addPlayer": "Add a player",
  "addPlayerPh": "Search players…",
  "noPlayerMatch": "No players match.",
  "overrideHint": "Added players count as inside wherever they are; taken-out players never do. Everyone else is decided by their location.",
  "everyPlayer": "On every player",
  "onGroup": "On group {name}",
  "onPlayer": "On {name}",
  "rule_inside": "Plays only here",
  "rule_outside": "Doesn't play here",
  "rule_rule": "Part of a rule",
  "type_image": "Image",
  "type_video": "Video",
  "type_app": "App",
  "type_campaign": "Campaign",
  "type_playlist": "Playlist",
  "removeInsideQ": "Take {region} off “{name}”? It will play outside this region too.",
  "removeOutsideQ": "Take {region} off “{name}”? It will play inside this region too.",
  "contentRemoved": "{region} taken off “{name}”.",
  "contentAdded": "1 item now plays only inside {region}. | {n} items now play only inside {region}.",
  "alreadyHere": "Already plays only here",
  "addContentIntro": "The content you choose plays only on players in {region}, wherever it is published.",
  "addN": "Add | Add 1 | Add {n}",
  "noContent": "No content is restricted to this region.",
  "remove": "Remove",
  "inRule": "In a rule",
  "inRuleHint": "This region is part of a logic rule. Edit the restriction on the content to change it.",
  "addContent": "Add content",
  "addContentHint": "Content that doesn't use this region plays everywhere it is published.",
  "editRegion": "Edit region · {name}",
  "saved": "Region “{name}” saved.",
  "savedUpdating": "Region “{name}” saved · players using it are being updated.",
  "deleteQ": "Delete the region “{name}”?",
  "deleted": "Region “{name}” deleted.",
  "insideOf": "{n} of {total} located player inside. | {n} of {total} located players inside.",
  "playersInside": "{n} player inside | {n} players inside",
  "usedBy": "used by {n} restriction | used by {n} restrictions",
  "noMatch": "No regions match “{q}”.",
  "discardQ": "You have unsaved changes. Discard them?",
  "newRegion": "New region",
  "enterName": "Enter a name.",
  "setCentre": "Set the centre: search for a place or click the map.",
  "radiusRange": "The radius must be between 0.05 and 500 km.",
  "noPlaces": "No places found.",
  "searchUnavailable": "Place search is unavailable. Click the map instead.",
  "shape": "Shape",
  "shapeCircle": "Circle",
  "shapePolygon": "Draw an area",
  "findPlace": "Find a place",
  "polygonHint": "Then click the map to place the corners of the area, in order around it.",
  "needPoints": "Click the map to place at least 3 corners.",
  "pointsNeeded": "Place 1 more corner | Place {n} more corners",
  "areaPoints": "Area · {n} corners",
  "undoPoint": "Undo last corner",
  "clearPoints": "Clear",
  "polygonEditHint": "Drag a corner to move it, drag the small dot on an edge to add a corner, double-click a corner to remove it. Drag inside the area to move all of it.",
  "dragHint": "Drag inside the circle to move it; drag its edge (or the white handle) to make it bigger or smaller.",
  "title": "Regions",
  "intro": "Areas on the map. Use them in restrictions to play content only on players inside (or outside) them.",
  "newRegionBtn": "Draw a region",
  "mapLabel": "Regions map",
  "close": "Close",
  "name": "Name",
  "namePh": "e.g. Manama city centre",
  "centre": "Centre",
  "searchPlace": "Search a place…",
  "orClick": "…or click the map. Drag the blue dot to fine-tune.",
  "searching": "Searching…",
  "noCentre": "No centre yet",
  "radiusKm": "Radius (km)",
  "radiusSlider": "Radius slider",
  "km": "km",
  "cancel": "Cancel",
  "saving": "Saving…",
  "createRegion": "Create region",
  "saveChanges": "Save changes",
  "searchRegions": "Search regions",
  "showOnMap": "Show on map",
  "edit": "Edit",
  "delete": "Delete",
  "removeFirst": "Remove it from its restrictions first",
  "noRegions": "No regions yet",
  "emptyHint": "Draw an area, then use it in a restriction to play content only there.",
  "locationNote": "A player's location is the latitude/longitude set on it in Players → Edit. Players without one are inside no region."
};
const ar: typeof en = {
  "manage": "الشاشات والمحتوى",
  "editShape": "تعديل الشكل",
  "tabPlayers": "الشاشات · {n}",
  "tabContent": "المحتوى · {n}",
  "m_location": "داخل المنطقة",
  "m_included": "أُضيفت يدويًا",
  "m_excluded": "أُخرجت يدويًا",
  "m_nearby": "قريبة",
  "mNearby": "خارجها بـ {d}",
  "src_manual": "موقع محدد يدويًا",
  "src_device": "موقع الجهاز",
  "src_ip": "تقدير من عنوان الإنترنت",
  "src_none": "بلا موقع",
  "online": "متصلة",
  "offline": "غير متصلة",
  "inThisRegion": "في هذه المنطقة",
  "outsideOrOut": "أُخرجت أو خارجها بقليل",
  "noPlayersIn": "لا توجد شاشات في هذه المنطقة بعد.",
  "takeOut": "إخراج",
  "useLocation": "استخدام موقعها",
  "removeFromRegion": "إزالة",
  "putBack": "إرجاع",
  "addToRegion": "إضافة",
  "excludeQ": "إخراج «{name}» من {region}؟ ستبقى خارجها حتى لو كان موقعها داخلها.",
  "player_include": "أُضيفت {name} إلى {region}.",
  "player_exclude": "أُخرجت {name} من {region}.",
  "player_auto": "تتبع {name} موقعها في {region} من جديد.",
  "addPlayer": "إضافة شاشة",
  "addPlayerPh": "ابحث عن الشاشات…",
  "noPlayerMatch": "لا توجد شاشات مطابقة.",
  "overrideHint": "الشاشات المضافة تُعد داخل المنطقة أينما كانت، والمُخرجة لا تُعد أبدًا. أما البقية فيحددها موقعها.",
  "everyPlayer": "على كل الشاشات",
  "onGroup": "على المجموعة {name}",
  "onPlayer": "على {name}",
  "rule_inside": "يُعرض هنا فقط",
  "rule_outside": "لا يُعرض هنا",
  "rule_rule": "جزء من قاعدة",
  "type_image": "صورة",
  "type_video": "فيديو",
  "type_app": "تطبيق",
  "type_campaign": "حملة",
  "type_playlist": "قائمة تشغيل",
  "removeInsideQ": "إزالة {region} من «{name}»؟ سيُعرض خارج هذه المنطقة أيضًا.",
  "removeOutsideQ": "إزالة {region} من «{name}»؟ سيُعرض داخل هذه المنطقة أيضًا.",
  "contentRemoved": "أُزيلت {region} من «{name}».",
  "contentAdded": "عنصر واحد يُعرض الآن داخل {region} فقط. | {n} عناصر تُعرض الآن داخل {region} فقط.",
  "alreadyHere": "يُعرض هنا فقط بالفعل",
  "addContentIntro": "المحتوى الذي تختاره يُعرض فقط على الشاشات في {region}، أينما نُشر.",
  "addN": "إضافة | إضافة 1 | إضافة {n}",
  "noContent": "لا يوجد محتوى مقيد بهذه المنطقة.",
  "remove": "إزالة",
  "inRule": "ضمن قاعدة",
  "inRuleHint": "هذه المنطقة جزء من قاعدة منطقية. عدّل القيد على المحتوى لتغييرها.",
  "addContent": "إضافة محتوى",
  "addContentHint": "المحتوى الذي لا يستخدم هذه المنطقة يُعرض أينما نُشر.",
  "editRegion": "تعديل المنطقة · {name}",
  "saved": "تم حفظ المنطقة «{name}».",
  "savedUpdating": "تم حفظ المنطقة «{name}» · يجري تحديث المشغلات التي تستخدمها.",
  "deleteQ": "حذف المنطقة «{name}»؟",
  "deleted": "تم حذف المنطقة «{name}».",
  "insideOf": "{n} من {total} مشغل محدد الموقع بالداخل. | {n} من مشغل واحد محدد الموقع بالداخل. | {n} من مشغلين محددَي الموقع بالداخل. | {n} من {total} مشغلات محددة الموقع بالداخل. | {n} من {total} مشغلًا محدد الموقع بالداخل. | {n} من {total} مشغل محدد الموقع بالداخل.",
  "playersInside": "لا مشغلات بالداخل | مشغل واحد بالداخل | مشغلان بالداخل | {n} مشغلات بالداخل | {n} مشغلًا بالداخل | {n} مشغل بالداخل",
  "usedBy": "غير مستخدمة في أي قيد | مستخدمة في قيد واحد | مستخدمة في قيدين | مستخدمة في {n} قيود | مستخدمة في {n} قيدًا | مستخدمة في {n} قيد",
  "noMatch": "لا توجد مناطق تطابق «{q}».",
  "discardQ": "لديك تغييرات غير محفوظة. هل تريد تجاهلها؟",
  "newRegion": "منطقة جديدة",
  "enterName": "أدخل اسمًا.",
  "setCentre": "حدّد المركز: ابحث عن مكان أو انقر على الخريطة.",
  "radiusRange": "يجب أن يكون نصف القطر بين ٠٫٠٥ و٥٠٠ كم.",
  "noPlaces": "لم يُعثر على أماكن.",
  "searchUnavailable": "البحث عن الأماكن غير متاح. انقر على الخريطة بدلًا من ذلك.",
  "shape": "الشكل",
  "shapeCircle": "دائرة",
  "shapePolygon": "رسم منطقة",
  "findPlace": "ابحث عن مكان",
  "polygonHint": "ثم انقر على الخريطة لوضع زوايا المنطقة بالترتيب حولها.",
  "needPoints": "انقر على الخريطة لوضع 3 زوايا على الأقل.",
  "pointsNeeded": "ضع زاوية أخرى | ضع {n} زوايا أخرى",
  "areaPoints": "منطقة · {n} زوايا",
  "undoPoint": "تراجع عن آخر زاوية",
  "clearPoints": "مسح",
  "polygonEditHint": "اسحب زاوية لتحريكها، واسحب النقطة الصغيرة على الحافة لإضافة زاوية، وانقر مرتين على زاوية لحذفها. اسحب داخل المنطقة لتحريكها كلها.",
  "dragHint": "اسحب داخل الدائرة لتحريكها، واسحب حافتها (أو المقبض الأبيض) لتكبيرها أو تصغيرها.",
  "title": "المناطق",
  "intro": "مناطق على الخريطة. استخدمها في القيود لعرض المحتوى فقط على المشغلات داخلها (أو خارجها).",
  "newRegionBtn": "ارسم منطقة",
  "mapLabel": "خريطة المناطق",
  "close": "إغلاق",
  "name": "الاسم",
  "namePh": "مثل: وسط مدينة المنامة",
  "centre": "المركز",
  "searchPlace": "ابحث عن مكان…",
  "orClick": "…أو انقر على الخريطة. اسحب النقطة الزرقاء للضبط الدقيق.",
  "searching": "جارٍ البحث…",
  "noCentre": "لا يوجد مركز بعد",
  "radiusKm": "نصف القطر (كم)",
  "radiusSlider": "شريط نصف القطر",
  "km": "كم",
  "cancel": "إلغاء",
  "saving": "جارٍ الحفظ…",
  "createRegion": "إنشاء منطقة",
  "saveChanges": "حفظ التغييرات",
  "searchRegions": "البحث في المناطق",
  "showOnMap": "عرض على الخريطة",
  "edit": "تعديل",
  "delete": "حذف",
  "removeFirst": "أزلها من قيودها أولًا",
  "noRegions": "لا توجد مناطق بعد",
  "emptyHint": "ارسم منطقة، ثم استخدمها في قيد لعرض المحتوى هناك فقط.",
  "locationNote": "موقع المشغل هو خط العرض/الطول المحدد له في المشغلات ← تعديل. والمشغلات التي بلا موقع خارج كل المناطق."
};
export default { en, ar };
